module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_1.ba4161c1f4b2a035bda76479f75eeea0.png";